@if (!modalType && !disconect) {
  <div class="upload-doc-wrapper vh-100 vw-100 overflow-hidden">
    <div class="upload-inner h-100 w-100 ovweflow-hiden">
      <div class="upload-doc-header hw-65 w-100 d-flex align-items-center justify-content-between border-bottom px-3">
        <img src="assets/images/icons/fm-white-icon.svg" alt="">
        @if (currentStep === 2) {
          <img src="assets/images/icons/cross-icon.svg" class="hw-32 border rounded-circle p-1 cursor" (click)="currentStep = 1" alt="">
        }
      </div>
      <div class="upload-doc-body h-100 overflow-auto hide-scroll-bar p-4 mx-auto">
        @if (currentStep === 1) {
          <div class="text-center">
            <img src="assets/images/icons/upload-doc.png" class="mb-4" alt="">
            <p class="fs-12 fw-700 py-1 px-4 rounded-pill mb-4 w-fit mx-auto" style="color: rgba(134, 67, 1, 1);background: linear-gradient(90deg, #FFF2CF 0%, #FFDF8D 100%);">
              Fast & Secure AutoFill
            </p>
            <h4 class="fs-24 fw-800 mb-3 black-16">Upload Identity Document</h4>
            <p class="fs-16 fw-400 grey-65 mb-4">
              Choose the document you want to upload for verification.
            </p>
          </div>
          <div class="mb-3 row">
            <div class="col-12 col-lg-6 mb-4">
              <button type="button" class="doc-option w-100 radius-16 p-4 h-100" [class.is-active]="selectedIdType === 'drivers_license'"
                (click)="selectedIdType = 'drivers_license'; currentStep = 2">
                <img src="assets/images/icons/blue-upload-icon.svg" class="mb-3" alt="">
                <h4 class="fs-18 fw-600 black-16 mb-2">Driver’s License</h4>
                <p class="fs-14 fw-400 m-0">
                  Upload customer’s driver license to auto-fill the details quickly and accurately.
                </p>
              </button>
            </div>
            <div class="col-12 col-lg-6 mb-4">
              <button type="button" class="doc-option w-100 radius-16  p-4 h-100" [class.is-active]="selectedIdType === 'another_proof'"
                (click)="selectedIdType = 'another_proof'; currentStep = 2">
                <img src="assets/images/icons/blue-upload-icon.svg" class="mb-3" alt="">
                <h4 class="fs-18 fw-600 black-16 mb-2">Another Proof of Identity</h4>
                <p class="fs-14 fw-400 m-0">
                  Upload a passport, state ID, or another government-issued document.
                </p>
              </button>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center p-4 radius-16" style="background: rgba(237, 253, 243, 1);">
            <img src="/assets/images/icons/shield-check.svg" class="me-2" alt="">
            <p class="fs-12 fw-600 m-0 text-success">
              Your information is secured and used solely to support your financing application.
            </p>
          </div>
        }
        @if (currentStep === 2) {
          @if (selectedIdType === 'drivers_license') {
            <div class="upload-doc-mobile__panel">
              <h4 class="fs-20 fw-800 black-40 mb-3">Upload Customer’s Driver License</h4>
              <p class="fs-16 fw-400 black-70 mb-4 ">
                Upload customer’s driver license to auto-fill the details quickly and accurately.
              </p>
              <div class="row">
                <div class="col-12 col-lg-6 mb-4">
                  <div class="upload-tile position-relative radius-16 p-4 d-flex align-items-center justify-content-center flex-column h-100" (click)="!identityFiles.front ? frontFileInput.click() : null">
                    @if (!identityPreviews.front) {
                      <img src="assets/images/icons/blue-upload-icon.svg" class="mb-2" alt="">
                      <p class="fs-16 fw-500 grey-65 m-0">Upload Front Side</p>
                    }
                    @if (identityPreviews.front) {
                      @if (isImage(identityFiles.front)) {
                        <img [src]="identityPreviews.front"
                          class="w-100 h-100" alt="Front Preview">
                      }
                      @if (!isImage(identityFiles.front)) {
                        <div class="upload-tile__file">{{
                        identityFiles.front?.name }}</div>
                      }
                      <img src="assets/images/icons/cross-icon.svg" class="hw-32 border rounded-circle p-1 cursor position-absolute bg-white" style="top: -16px;right: -16px;"  (click)="removeIdentityFile('front'); $event.stopPropagation()" alt="">
                    }
                    <input #frontFileInput type="file" (change)="onIdentityFileSelected($event, 'front')"
                      accept=".pdf, .jpeg, .jpg, .png" style="display: none;">
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 mb-4">
                    <div class="upload-tile position-relative radius-16 p-4 d-flex align-items-center justify-content-center flex-column h-100" (click)="!identityFiles.back ? backFileInput.click() : null">
                      @if (!identityPreviews.back) {
                        <img src="assets/images/icons/blue-upload-icon.svg" class="mb-2" alt="">
                        <p class="fs-16 fw-500 grey-65 m-0">Upload Back Side</p>
                      }
                      @if (identityPreviews.back) {
                        @if (isImage(identityFiles.back)) {
                          <img [src]="identityPreviews.back"
                            class="w-100 h-100" alt="Back Preview">
                        }
                        @if (!isImage(identityFiles.back)) {
                          <div class="upload-tile__file">{{
                          identityFiles.back?.name }}</div>
                        }
                        <img src="assets/images/icons/cross-icon.svg" class="hw-32 border rounded-circle p-1 cursor position-absolute bg-white" style="top: -16px;right: -16px;"  (click)="removeIdentityFile('back'); $event.stopPropagation()" alt="">
                      }
                      <input #backFileInput type="file" (change)="onIdentityFileSelected($event, 'back')"
                        accept=".pdf, .jpeg, .jpg, .png" style="display: none;">
                      </div>
                    </div>
                  </div>
                  <!-- <div class="mb-3" *ngIf="showDobForLicense">
                  <app-date-of-birth [dobSubscription]="dobSubscription" [dobData]="dobData" [fromPage]="'contractCreation'"
                  (submittedData)="getDob($event)"></app-date-of-birth>
                  <p class="mat-error text-danger w-100 d-block mb-0 fs-12" *ngIf="showDobError">
                  Please enter valid date of birth</p>
                </div> -->
              </div>
            }
            @if (selectedIdType === 'another_proof') {
              <div class="upload-doc-mobile__panel">
                <h4  class="fs-20 fw-800 black-40 mb-3">Proof of Identity</h4>
                <p class="fs-16 fw-400 black-70 mb-4 ">
                  Upload a passport, state ID, or another government-issued document.
                </p>
                <div class="row">
                  <div class="col-12 mb-4">
                    <div class="upload-tile position-relative radius-16 p-4 d-flex align-items-center justify-content-center flex-column h-100"
                      (click)="!identityFiles.proof ? proofFileInput.click() : null">
                      @if (!identityPreviews.proof) {
                        <img src="assets/images/icons/blue-upload-icon.svg" class="mb-2" alt="">
                        <p class="fs-16 fw-500 grey-65 m-0">Upload File Here</p>
                      }
                      @if (identityPreviews.proof) {
                        @if (isImage(identityFiles.proof)) {
                          <img [src]="identityPreviews.proof"
                            class="w-100 h-100" alt="Proof Preview">
                        }
                        @if (!isImage(identityFiles.proof)) {
                          <div class="upload-tile__file">{{
                          identityFiles.proof?.name }}</div>
                        }
                        <img src="assets/images/icons/cross-icon.svg" class="hw-32 border rounded-circle p-1 cursor position-absolute bg-white" style="top: -16px;right: -16px;"  (click)="removeIdentityFile('proof'); $event.stopPropagation()" alt="">
                      }
                      <input #proofFileInput type="file" (change)="onIdentityFileSelected($event, 'proof')"
                        accept=".pdf, .jpeg, .jpg, .png" style="display: none;">
                      </div>
                      <!-- <div class="div">
                      <app-date-of-birth [dobSubscription]="dobSubscription" [dobData]="dobData" [fromPage]="'contractCreation'"
                      (submittedData)="getDob($event)"></app-date-of-birth>
                      <p class="mat-error text-danger w-100 d-block mb-0 fs-12" *ngIf="showDobError">
                      Please enter valid date of birth</p>
                    </div> -->
                  </div>
                </div>
              </div>
            }
            <button class="btn btn-secondary fw-700 w-100" (click)="uploadIdentity()">Continue</button>
          }
          @if (currentStep === 3) {
            <div class="text-center">
              <img src="assets/images/icons/tick-star-icon.png" class="mb-3" alt="">
              <h4 class="fs-24 fw-800 black-40 mb-3">Details Submitted!</h4>
              <p class="fs-16 fw-600 grey-70 m-0">
                Your details have been submitted successfully. You can now continue on the web portal to complete the process.
              </p>
            </div>
          }
        </div>
        <div class="upload-doc-fotter hw-65 w-100 d-flex align-items-center justify-content-center border-top px-3">
          <div class="text-center text-sm-end col-sm-6">
            <p class="fs-12 m-0">
              <img src="assets/images/icons/fm-logo-circle.svg" alt="" class="hw-24 rounded mx-2 border">
              Powered by <strong class="mb-0" style="color: rgba(18, 44, 11, 1);">FinanceMutual<sup>TM</sup></strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  }
  @if (!modalType && disconect) {
    <div class="finance-wrapper vh-96">
      <div class="plans-header d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
        <img src="assets\images\icons\FM-logo-green.svg" alt="">
      </div>
      <div class="finance-inner overflow-hidden position-relative">
        <div class="finance-body overflow-auto p-4 d-flex justify-content-center">
          <div class="mxw-450 d-flex align-items-center justify-content-center flex-column text-center">
            <img src="assets/images/icons/Process_discontinue.png" alt="" class="mb-5">
            <p class="fs-18 fw-700 mxw-450 mx-auto ">
              Process Discontinued...
            </p>
            <p class="fs-16 fw-400 mxw-450 mx-auto ">
              Please scan QR-Code again.
            </p>
          </div>
        </div>
      </div>
    </div>
  }
  @if (modalType && modalType === 'UPLOAD_IDENTITY') {
    <div class="modal-dialog m-0 p-0 document">
      <div class="modal-header align-items-center justify-content-between border-0 pb-0 px-4 pt-4">
        <div>
          <h4 class="fs-18 fw-700 m-0 mb-1">Upload Customer's Identity</h4>
          <p class="fs-14 fw-400 m-0" style="color: #6A6A6A;">
            Upload a clear copy of your Driver's License or another government-issued proof of ID.
          </p>
        </div>
        <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-30 cursor border rounded-circle p-1"
          (click)="onClose()">
        </div>
        <div class="modal-body px-4 pt-3 pb-4">
          <!-- <div class="d-flex align-items-center mb-4">
          <div class="form-check me-4 ps-0">
            <input class="secondary-radio" type="radio" name="idType" id="driversLicense"
              value="drivers_license" [(ngModel)]="selectedIdType" (ngModelChange)="onIdTypeChange()">
              <label class="form-check-label fs-14 fw-600" for="driversLicense">
                Driver's License
              </label>
            </div>
            <div class="form-check">
              <input class="secondary-radio" type="radio" name="idType" id="anotherProof"
                value="another_proof" [(ngModel)]="selectedIdType" (ngModelChange)="onIdTypeChange()">
                <label class="form-check-label fs-14 fw-600" for="anotherProof">
                  Another Proof of Identity
                </label>
              </div>
            </div> -->
            @if (selectedIdType === 'drivers_license') {
              <div class="row">
                <div class="col-6 position-relative">
                  <div class="upload-zone text-center p-3 cursor radius-8 position-relative"
                    style="border: 1px dashed #C9CAD9; min-height: 140px;"
                    (click)="!identityFiles.front ? frontFileInput.click() : null">
                    @if (!identityPreviews.front) {
                      <img src="assets/images/icons/blue-upload-icon.svg" alt="" class="mb-2 hw-40">
                      <p class="fs-14 fw-600 m-0" style="color: #6A6A6A;">Front Side</p>
                    }
                    @if (identityPreviews.front) {
                      @if (isImage(identityFiles.front)) {
                        <img [src]="identityPreviews.front"
                          class="w-100 radius-8" style="max-height: 120px; object-fit: cover;" alt="Front Preview">
                      }
                      @if (!isImage(identityFiles.front)) {
                        <p class="fs-12 fw-500 m-0">{{ identityFiles.front?.name }}</p>
                      }
                      <span
                        class="position-absolute d-flex align-items-center justify-content-center hw-20 rounded-circle cursor bg-white" style="top: -10px;right: -10px;"
                        (click)="removeIdentityFile('front'); $event.stopPropagation()">
                        <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border rounded-circle p-1 cursor">
                      </span>
                    }
                  </div>
                  <input #frontFileInput type="file" (change)="onIdentityFileSelected($event, 'front')"
                    accept=".jpeg, .jpg, .png" style="display: none;">
                  </div>
                  <div class="col-6 position-relative">
                    <div class="upload-zone text-center p-3 cursor radius-8 position-relative"
                      style="border: 1px dashed #C9CAD9; min-height: 140px;"
                      (click)="!identityFiles.back ? backFileInput.click() : null">
                      @if (!identityPreviews.back) {
                        <img src="assets/images/icons/blue-upload-icon.svg" alt="" class="mb-2 hw-40">
                        <p class="fs-14 fw-600 m-0" style="color: #6A6A6A;">Back Side</p>
                      }
                      @if (identityPreviews.back) {
                        @if (isImage(identityFiles.back)) {
                          <img [src]="identityPreviews.back"
                            class="w-100 radius-8" style="max-height: 120px; object-fit: cover;" alt="Back Preview">
                        }
                        @if (!isImage(identityFiles.back)) {
                          <p class="fs-12 fw-500 m-0">{{ identityFiles.back?.name }}</p>
                        }
                        <span
                          class="position-absolute d-flex align-items-center justify-content-center hw-20 rounded-circle cursor bg-white" style="top: -10px;right: -10px;"
                          (click)="removeIdentityFile('back'); $event.stopPropagation()">
                          <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border rounded-circle p-1 cursor">
                        </span>
                      }
                    </div>
                    <input #backFileInput type="file" (change)="onIdentityFileSelected($event, 'back')"
                      accept=".jpeg, .jpg, .png" style="display: none;">
                    </div>
                  </div>
                  <!-- <div class="mt-4" *ngIf="showDobForLicense">
                  <app-date-of-birth [dobSubscription]="dobSubscription" [dobData]="dobData" [fromPage]="'contractCreation'"
                  (submittedData)="getDob($event)"></app-date-of-birth>
                  <p class="mat-error text-danger w-100 d-block mb-0 fs-12" *ngIf="showDobError">
                  Please enter valid date of birth</p>
                </div> -->
              }
              @if (selectedIdType === 'another_proof') {
                <div class="position-relative">
                  <div class="upload-zone text-center p-4 cursor radius-8 position-relative"
                    style="border: 1px dashed #C9CAD9; min-height: 140px;"
                    (click)="!identityFiles.proof ? proofFileInput.click() : null">
                    @if (!identityPreviews.proof) {
                      <img src="assets/images/icons/blue-upload-icon.svg" alt="" class="mb-2 hw-40">
                      <p class="fs-14 fw-600 m-0 text-primary">Upload File Here</p>
                    }
                    @if (identityPreviews.proof) {
                      @if (isImage(identityFiles.proof)) {
                        <img [src]="identityPreviews.proof"
                          class="w-100 radius-8" style="max-height: 120px; object-fit: cover;" alt="Proof Preview">
                      }
                      @if (!isImage(identityFiles.proof)) {
                        <p class="fs-12 fw-500 m-0">{{ identityFiles.proof?.name }}</p>
                      }
                      <span  class="position-absolute d-flex align-items-center justify-content-center hw-20 rounded-circle cursor bg-white" style="top: -10px;right: -10px;"
                        (click)="removeIdentityFile('proof'); $event.stopPropagation()">
                        <img src="assets/images/icons/cross-icon.svg" alt="" class="hw-32 border rounded-circle p-1 cursor">
                      </span>
                    }
                  </div>
                  <input #proofFileInput type="file" (change)="onIdentityFileSelected($event, 'proof')"
                    accept=".jpeg, .jpg, .png" style="display: none;">
                  </div>
                  <!-- <div class="mt-4">
                  <app-date-of-birth [dobSubscription]="dobSubscription" [dobData]="dobData" [fromPage]="'contractCreation'"
                  (submittedData)="getDob($event)"></app-date-of-birth>
                  <p class="mat-error text-danger w-100 d-block mb-0 fs-12" *ngIf="showDobError">
                  Please enter valid date of birth</p>
                </div> -->
              }
            </div>
            <div class="modal-footer border-0 px-4 pb-4 pt-0 d-flex align-items-center justify-content-between">
              <button class="btn btn-secondary fw-700 px-4" (click)="uploadIdentity()">Continue</button>
              <p class="fs-16 fw-700 m-0 text-primary cursor" (click)="selectedIdType  === 'another_proof' ? selectedIdType  = 'drivers_license' : selectedIdType  = 'another_proof'">
                {{selectedIdType  === 'another_proof' ? 'Or Driver’s License' : 'Or Another Proof of Identity'}}
              </p>
            </div>
          </div>
        }